(() => {
  const hoverStyleId = 'lp-about-hover-polish';

  if (!document.getElementById(hoverStyleId)) {
    const style = document.createElement('style');
    style.id = hoverStyleId;
    style.textContent = `
      .lp-about__hero-media img,
      .lp-about__story-media img,
      .lp-about__visit-media img,
      .lp-about__gallery-track figure img {
        transition: transform .55s cubic-bezier(.2,.7,.2,1);
      }

      .lp-about__hero-media figcaption,
      .lp-about__quick span,
      .lp-about__story-points > div,
      .lp-about__principles-list article,
      .lp-about__icon,
      .lp-about__gallery-track figure,
      .lp-about__gallery-track figcaption,
      .lp-about__visit-details > div {
        transition:
          transform .24s cubic-bezier(.2,.7,.2,1),
          box-shadow .24s ease,
          border-color .24s ease,
          background-color .24s ease,
          color .24s ease;
      }

      @media (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference) {
        .lp-about__hero-media:hover img,
        .lp-about__story-media:hover img,
        .lp-about__visit-media:hover img {
          transform: scale(1.035);
        }

        .lp-about__hero-media:hover figcaption {
          transform: translateY(-2px);
          background: rgba(15, 51, 32, .92);
          box-shadow: 0 8px 20px rgba(15, 51, 32, .16);
        }

        .lp-about__quick span:hover,
        .lp-about__story-points > div:hover,
        .lp-about__visit-details > div:hover {
          transform: translateY(-3px);
          border-color: rgba(22, 101, 52, .24);
          box-shadow: 0 10px 24px rgba(20, 61, 39, .08);
        }

        .lp-about__principles-list article:hover {
          transform: translateY(-4px);
          border-color: rgba(22, 101, 52, .22);
          box-shadow: 0 14px 30px rgba(20, 61, 39, .10);
        }

        .lp-about__principles-list article:hover .lp-about__icon {
          transform: rotate(-3deg) scale(1.06);
          color: #fff;
          background: var(--g);
          box-shadow: 0 8px 18px rgba(22, 101, 52, .18);
        }

        .lp-about__gallery-track figure:hover {
          transform: translateY(-5px);
          border-color: rgba(22, 101, 52, .22);
          box-shadow: 0 16px 34px rgba(20, 61, 39, .12);
        }

        .lp-about__gallery-track figure:hover img {
          transform: scale(1.045);
        }

        .lp-about__gallery-track figure:hover figcaption {
          color: var(--g);
        }

        .lp-about__button--primary:hover {
          border-color: var(--gd);
          background: var(--gd);
        }

        .lp-about__button--secondary:hover,
        .lp-about__gallery-controls button:hover {
          background: var(--soft);
        }
      }
    `;
    document.head.appendChild(style);
  }

  document.querySelectorAll('.lp-about').forEach((root) => {
    if (root.dataset.lpReady === 'true') return;
    root.dataset.lpReady = 'true';

    const track = root.querySelector('[data-lp-about-track]');
    const prev = root.querySelector('[data-lp-about-prev]');
    const next = root.querySelector('[data-lp-about-next]');
    if (!track || !prev || !next) return;

    const move = (direction) => {
      const card = track.querySelector('figure');
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 10;
      const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * .82;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });
})();
